import {
	Column,
	Entity,
	Index,
	JoinColumn,
	ManyToOne,
	OneToOne,
} from 'typeorm';
import { AutomationStepExecutionEntity } from './automation-step-execution.entity';
import { BaseEntity } from './base.entity';
import { ConversationSessionEntity } from './conversation-session.entity';

@Entity('_conversation_call')
@Index(['callSid'], { unique: true })
@Index(['callStatus'])
@Index(['startedAt'])
@Index(['entityType', 'entityId'])
export class ConversationCallEntity extends BaseEntity {
	@Column({
		name: 'call_sid',
		type: 'varchar',
		length: 100,
		unique: true,
		nullable: true,
	})
	public callSid?: string;

	@Column({
		name: 'call_provider',
		type: 'varchar',
		length: 50,
		comment: 'Provider used for the call (twilio, vonage, etc.)',
	})
	public callProvider!: string;

	@Column({
		name: 'call_status',
		type: 'varchar',
		length: 50,
		default: "'initiated'",
		comment:
			'Status: initiated, ringing, in-progress, completed, failed, busy, no-answer',
	})
	public callStatus!: string;

	@Column({
		name: 'call_direction',
		type: 'varchar',
		length: 20,
		comment: 'inbound or outbound',
	})
	public callDirection!: 'inbound' | 'outbound';

	@Column({
		name: 'phone_from',
		type: 'varchar',
		length: 50,
		comment: 'Caller phone number',
	})
	public phoneFrom!: string;

	@Column({
		name: 'phone_to',
		type: 'varchar',
		length: 50,
		comment: 'Recipient phone number',
	})
	public phoneTo!: string;

	@Column({
		name: 'fk__automation_step_execution__id',
		type: 'int',
		unsigned: true,
		nullable: true,
	})
	public automationStepExecutionId?: number;

	@ManyToOne(() => AutomationStepExecutionEntity, { nullable: true })
	@JoinColumn({
		name: 'fk__automation_step_execution__id',
		referencedColumnName: 'id',
	})
	public automationStepExecution?: AutomationStepExecutionEntity;

	@Column({
		name: '_entity_type',
		type: 'varchar',
		length: 50,
		nullable: true,
		comment: 'Entity type that was called (e.g., client)',
	})
	public entityType?: string;

	@Column({
		name: '_entity_id',
		type: 'varchar',
		length: 255,
		nullable: true,
		comment: 'Entity ID that was called',
	})
	public entityId?: string;

	@Column({
		name: 'started_at',
		type: 'timestamp',
		nullable: true,
		comment: 'When the call was initiated',
	})
	public startedAt?: Date;

	@Column({
		name: 'answered_at',
		type: 'timestamp',
		nullable: true,
		comment: 'When the call was answered',
	})
	public answeredAt?: Date;

	@Column({
		name: 'ended_at',
		type: 'timestamp',
		nullable: true,
		comment: 'When the call ended',
	})
	public endedAt?: Date;

	@Column({
		name: 'duration_seconds',
		type: 'int',
		nullable: true,
		comment: 'Call duration in seconds',
	})
	public durationSeconds?: number;

	@Column({
		name: 'metadata',
		type: 'json',
		nullable: true,
		comment: 'Provider-specific data and additional metadata',
	})
	public metadata?: any;

	// Reverse relation from ConversationSession
	@OneToOne(() => ConversationSessionEntity, (session) => session.call)
	public session?: ConversationSessionEntity;
}
